const Utils = {
  FIND_URL_REGEX: /(\b|_)((?:https?|ftp|missive):\/\/[\-A-Z0-9+\u00C0-\u017F\u0026\u2019@\#\*\/%?=()~_|!:,.;^]*[\-A-Z0-9+\u00C0-\u017F\u0026\#\/%=~()_|])/gi,
  FIND_TEL_REGEX: /{{\s*tel:\s*(.+?)\s*}}/gi,
  FIND_LINK_REGEX: /{{\s*link:\s*(.+?)(?:\s(.+?))??\s*}}/gi,
  FIND_EMAIL_REGEX: /(?:mailto:\/*)?(\w[\w.\-\+]*@\w[\w.\-]*\.\w+)/gi,
  EMAIL_REGEX: /^(?:mailto:\/*)?(\w[\w.\-\+]*@\w[\w.\-]*\.\w+)$/i,

  now: function() {
    return Math.floor(Date.now() / 1000)
  },

  isToday: function(date) {
    let now = new Date()
    return now.getDate() != date.getDate() || now.getMonth() != date.getMonth()
  },

  formatTimestamp: function(timestamp) {
    let date = new Date(timestamp * 1000)
    let options

    if (this.isToday(date)) {
      options = {
        hour: 'numeric',
        minute: 'numeric',
        month: 'short',
        day: 'numeric',
      }
    } else {
      options = { hour: 'numeric', minute: 'numeric' }
    }

    return Intl.DateTimeFormat(undefined, options).format(date)
  },

  bytesToSize: function(bytes) {
    if (!bytes) return '0 Byte'

    const k = 1024
    const sizes = [' Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    let i = Math.floor(Math.log(bytes) / Math.log(k))
    let size = (bytes / Math.pow(k, i)).toPrecision(3)
    size = Math.round(size * 100) / 100

    if (size == k) {
      size = 1
      i += 1
    }

    return `${size}${sizes[i]}`
  },

  classNames(classes) {
    let classNames = []

    for (let k in classes) {
      if (classes[k]) {
        classNames.push(k)
      }
    }

    return classNames.join(' ')
  },

  isMobile() {
    return this._isMobile != undefined
      ? this._isMobile
      : (this._isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        ))
  },
}

export default Utils
